import { trackEvent } from '@finn-no/pulse-sdk'
import { config } from '@finn-no/huck-config'

const NAME = 'Purchase used car guarantee'
const POSITION = 'Ad insertion'
const UI_ELEMENT = 'UIElement'
const CHECKBOX = 'Checkbox'
const getItems = () => ([{ type: 'ClassifiedAd', id: config.adId }])

export const view = () => trackEvent({
  type: 'View',
  intent: 'Show',
  name: NAME,
  object: {
    type: UI_ELEMENT,
    elementType: 'Info box',
    position: POSITION,
    items: getItems(),
  },
})

export const check = () => trackEvent({
  type: 'Click',
  intent: 'Accept',
  name: NAME,
  object: {
    type: UI_ELEMENT,
    elementType: CHECKBOX,
    position: POSITION,
    items: getItems(),
  },
})

export const uncheck = () => trackEvent({
  type: 'Click',
  intent: 'Dismiss',
  name: NAME,
  object: {
    type: UI_ELEMENT,
    elementType: CHECKBOX,
    position: POSITION,
    items: getItems(),
  },
})
